export interface IResponseError {
  responseError: true;
  status: number; // http status
  detail: string;
  isCancel: boolean;
}

interface DPResponseError {
  code: number;
  message: string;
  metadata: Record<string, unknown>;
  reason: string;
}

export function toIResponseError(err: unknown): IResponseError {
  if (isResponseError(err)) {
    return err;
  }
  if (isDPResponseError(err)) {
    return {
      responseError: true,
      status: err.code,
      detail: err.message,
      isCancel: false,
    };
  }
  console.debug("toIResponseError: unknown error", err);
  return {
    responseError: true,
    status: 500,
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    detail: String(err ?? "unknown error"),
    isCancel: false,
  };
}

function isResponseError(payload: unknown): payload is IResponseError {
  const maybeErr = payload as any;
  return !!maybeErr.responseError;
}

function isDPResponseError(payload: unknown): payload is DPResponseError {
  const maybeErr = payload as any;
  return !!maybeErr.code;
}
